
/**
 * Utilitários para formatação de telefone
 * 
 * Funcionalidades:
 * - Formatação de telefone com DDD entre parênteses
 * - Suporte para números com e sem código do país
 * - Fallback para números inválidos
 */

/**
 * Formatar telefone no padrão brasileiro (11) 98765-4321
 * 
 * @param telefone - Número de telefone em formato bruto
 * @returns Telefone formatado ou string original se inválido
 */
export const formatarTelefone = (telefone: string | null | undefined): string => {
  if (!telefone) return '';
  
  // Remove todos os caracteres não numéricos
  const numeroLimpo = telefone.replace(/\D/g, '');
  
  // Se não tem números suficientes, retorna original
  if (numeroLimpo.length < 10) return telefone;
  
  // Remove código do país se presente (55)
  let numero = numeroLimpo;
  if (numero.startsWith('55') && numero.length >= 12) {
    numero = numero.substring(2);
  }
  
  // Formatação para celular (11 dígitos) - (11) 98765-4321
  if (numero.length === 11) {
    const ddd = numero.substring(0, 2);
    const parte1 = numero.substring(2, 7);
    const parte2 = numero.substring(7, 11);
    return `(${ddd}) ${parte1}-${parte2}`;
  }
  
  // Formatação para telefone fixo (10 dígitos) - (11) 8765-4321
  if (numero.length === 10) {
    const ddd = numero.substring(0, 2);
    const parte1 = numero.substring(2, 6);
    const parte2 = numero.substring(6, 10);
    return `(${ddd}) ${parte1}-${parte2}`;
  }
  
  // Se não conseguiu formatar, retorna original
  return telefone;
};

/**
 * Verificar se um telefone é celular (9 dígitos após DDD)
 * 
 * @param telefone - Número de telefone
 * @returns true se é celular, false caso contrário
 */
export const isCelular = (telefone: string | null | undefined): boolean => {
  if (!telefone) return false;
  
  const numeroLimpo = telefone.replace(/\D/g, '');
  let numero = numeroLimpo;
  
  // Remove código do país se presente
  if (numero.startsWith('55') && numero.length >= 12) {
    numero = numero.substring(2);
  }
  
  // Celular tem 11 dígitos e o terceiro dígito é 9
  return numero.length === 11 && numero[2] === '9';
};
